module.exports = __webpack_public_path__ + "assets/img/gn3.41c712a1.png";